import GridDefaultDesktop from './desktop'
import { GridDisplay, GridOrientation } from './enum'
import GridDefaultMobile from './mobile'

import type { BaseGridProps } from './types'

import { CardOrientation } from '../customCard/base/enum'

const Grid = ({
  children,
  cardOrientation = CardOrientation.HORIZONTAL,
  gridOrientation = GridOrientation.HORIZONTAL,
  className,
  type = GridDisplay.DESKTOP,
  isCarousel = false
}: BaseGridProps) => {
  return type === GridDisplay.MOBILE ? (
    <GridDefaultMobile
      isCarousel={isCarousel}
      gridOrientation={gridOrientation}
      className={className}>
      {children}
    </GridDefaultMobile>
  ) : (
    <GridDefaultDesktop
      cardOrientation={cardOrientation}
      gridOrientation={gridOrientation}
      className={className}>
      {children}
    </GridDefaultDesktop>
  )
}

export default Grid
